// We grab each slide (menu item) from a class since this allows us to provide a way to setup this up as an author in shogun
const print = (string) => {
    if(CONFIG.DEBUG_MODE){
        console.log(string)
    }
}

const CONFIG = {
    DEBUG_MODE: false,
    INTERSECTION_THRESHOLD: 0.45,
    OFFSET_LINKS: {
        ENABLED: true,
        AMOUNT: 100
    }
}

const swiperShogun = new Swiper('.swiper-shogun-menu', {
    slidesPerView: "auto",
    loop: false,
    navigation: {
        nextEl: '.carousel-button-next',
        prevEl: '.carousel-button-prev',
        disabledClass: "hidden"
    }
});

const createStickyMenu = (shogunMenuItems) => {
    let shogunMenu = document.querySelector(".swiper-shogun-menu")
    let shogunStaticMenu = document.querySelector(".shogun-static-menu")

    const shogunMenuWrapper = shogunMenu.querySelector(".swiper-wrapper")

    if(CONFIG)
    print("creating sticky menu for shogun block")

    shogunMenuItems.forEach(shogunMenuItem => {
        let shogunClassName = null
        
        shogunMenuItem.classList.forEach((smiClassElement, index) => {
            if(smiClassElement.includes("smi-")){
                shogunClassName = smiClassElement

                if(!shogunMenuItem.id){
                    shogunMenuItem.id = smiClassElement
                }

                if(CONFIG.OFFSET_LINKS.ENABLED){
                    // offset for links not taking offset or menu height into account
                    // could have a custom js event with smooth scroll, probably the best way to go tbh
                
                    if (!smiClassElement.includes("review")) {
                        shogunMenuItem.style["margin-top"] = `-${CONFIG.OFFSET_LINKS.AMOUNT}px`
                        shogunMenuItem.style["padding-top"] = `${CONFIG.OFFSET_LINKS.AMOUNT}px`
                    }
                }

                // Create new slide and add
                let newShogunSlide = document.createElement("a")
                newShogunSlide.innerHTML = `${shogunClassName.split("-")[1].replace("_", " ")}`
                newShogunSlide.classList.add(`link-${smiClassElement}`)
                newShogunSlide.href=`#${shogunMenuItem.id}`
                newShogunSlide.classList.add("swiper-slide")
                newShogunSlide.classList.add("transition")
                newShogunSlide.classList.add("whitespace-nowrap")
                shogunMenuWrapper.appendChild(newShogunSlide)
                
                // create new static link
                if (shogunStaticMenu){
                    let newShogunLink = document.createElement("a")
                    newShogunLink.innerHTML = `${shogunClassName.split("-")[1].replace("_", " ")}`
                    newShogunLink.href=`#${shogunMenuItem.id}`
                    shogunStaticMenu.appendChild(newShogunLink)
                }

                shogunMenu.classList.remove("hidden")
            }
        })
    })
}

let shogunMenuItems = document.querySelectorAll('[class*="smi-"]');

shogunMenuItems.forEach((ele, index) => {
    ele.setAttribute("swiperindex", index);
})

if (shogunMenuItems.length > 0) {
    createStickyMenu(shogunMenuItems);
}

let highestIndex = 0

const changeNav = (entries, observer) => {
    print("change nav running")
    let changed = false

	entries.forEach((entry, index) => {
		// verify the element is intersecting
		if(entry.isIntersecting && entry.intersectionRatio >= CONFIG.INTERSECTION_THRESHOLD && !changed) {
			// remove old active class
			let eles = document.querySelectorAll('.smi-active')

            let indexTo = entry.target.getAttribute("swiperindex")
            if (indexTo > highestIndex) highestIndex = indexTo;

			if(eles){
                eles.forEach((ele) => {
                    if(!ele) return;

                    ele.classList.remove('smi-active')
                })
            }

            // get id of the intersecting section
			var id = entry.target.getAttribute('id');

			// find matching link & add appropriate class
			var newLinks = document.querySelectorAll(`[href="#${id}"]`)
            
            if (newLinks){
                newLinks.forEach((newLink) => {
                    if(!newLink) return;

                    print(`moving to index: ${indexTo}`)

                    swiperShogun.slideTo(indexTo, 100, true)

                    setTimeout(() => {
                        let navMobile = document.querySelector(".swiper-shogun-menu")
                        let activesMobile = navMobile.querySelectorAll(".smi-active")
                        
                        activesMobile.forEach(ele => {
                            ele.classList.remove("smi-active")
                        })
                        
                        let navDesktop = document.querySelector(".js-product-atc-bar")
                        let activesDesktop = navDesktop.querySelectorAll(".smi-active")
                        
                        if(activesDesktop.length > 1){
                            activesDesktop.forEach((ele, index) => {
                                console.log(`actives length = ${activesDesktop.length} - index = ${index}`)

                                if(index < 1){
                                    ele.classList.remove("smi-active")
                                }
                            })
                        }

                        newLink.classList.add('smi-active');
                    }, 100)
                })
            }

            changed = true
		}
	});
}

const observer = new IntersectionObserver(changeNav, {
    threshold: CONFIG.INTERSECTION_THRESHOLD
});

// target the elements to be observed
const sections = document.querySelectorAll('[class*="smi-"]');
sections.forEach((section) => {
	observer.observe(section);
});